import { CreateElement } from 'vue'
import { RouteConfig } from 'vue-router'
import { CreateRouterOptions } from '@/typings/common'

import { LK_REPORT_DATA_COLLECTIONS_ROUTES as ROUTES } from './utils'
import { lkStoreModule } from '@/store/modules/lk'


type Options = Required<CreateRouterOptions>
type PromiseVue = Promise<typeof import('*.vue')>

const createRoutes = (options: Options): RouteConfig[] => [
  {
    path: 'reports-data-collections',
    name: ROUTES.LAYOUT,
    redirect: { name: ROUTES.LIST },
    meta: { authorized: true },
    async beforeEnter(to, from, next) {
      const storeModule = lkStoreModule.context(options.store)

      if (storeModule.getters.isPublicationCurator) {
        next()
        return
      }

      await storeModule.actions.checkIsAutoCurator()

      if (storeModule.getters.hasDataCollectionAccess) {
        next()
        return
      }

      next({ name: 'lk-profile' })
    },
    component: {
      name: 'ViewLKReportsDataCollectionsLayout',
      render: (h: CreateElement) => h('router-view'),
    },
    children: [
      {
        path: '',
        name: ROUTES.LIST,
        meta: {},
        component: (): PromiseVue => import(
          /* webpackChunkName: "lk-reports-data-collections.list" */
          './LKReportsDataCollectionsList.vue'
        ),
      },
    ],
  },
]

const createModule = (options: Options) => createRoutes(options)

export default createModule

